import Guard from '@/services/middleware'

const HomeTags = () => import('@/views/dash/settings/tags/HomeTags')

export default [
    {
        path: '/categoria-atendimento',
        name: 'attendanceCategory.home',
        component: HomeTags,
        meta: { title: 'Categoria de Atendimentos', permission: 2, module: 'mod_calls_classification' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
    {
        path: '/categoria-atendimento/:id',
        name: 'attendanceCategory.show',
        component: HomeTags,
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
        meta: { title: 'Detalhes da categoria', permission: 2, module: 'mod_calls_classification' },
    },
    {
        path: '/categoria-atendimento/cadastrar',
        name: 'attendanceCategory.create',
        component: HomeTags,
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
        meta: { title: 'Nova categoria de atendimento', permission: 2, module: 'mod_calls_classification' },
    },
    {
        path: '/categoria-atendimento/:action/remover',
        name: 'attendanceCategory.delete',
        component: HomeTags,
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
        meta: { title: 'Excluir categoria?', permission: 2, module: 'mod_calls_classification' },
    },
]